import { TextInput } from 'components'

const NumberInput = ({ type = 'integer', ...props }) => (
  <TextInput type="number" step={type === 'decimal' ? 0.01 : 1} {...props} />
)

export default NumberInput
